import { breakpoints } from "../helpers/breakpoints";
import { trapFocus } from "../helpers/util";

export const navigation = () => {
  const body: HTMLElement | null = document.querySelector("body");
  const hamburgerIcon: HTMLElement | null =
    document.querySelector("[js-nav-open]");
  const crossIcon: HTMLElement | null =
    document.querySelector("[js-nav-close]");
  const backdrop: HTMLElement | null = document.querySelector("[js-backdrop]");
  const nav: HTMLElement | null = document.querySelector("[js-nav]");

  const focusTimeout = 250;

  if (!body || !hamburgerIcon || !crossIcon || !backdrop || !nav) {
    return;
  }

  /* Open nav and show backdrop. Lock scrolling on main page */
  hamburgerIcon.addEventListener("click", () => {
    hamburgerIcon.setAttribute("aria-expanded", "true");
    backdrop.classList.add("backdrop-active");
    nav.classList.add("navigation-active");
    body.classList.add("overflow--hidden");

    setTimeout(() => {
      const item = nav.querySelector(
        window.innerWidth < breakpoints.screen1024
          ? 'select[name="currency"]'
          : 'button[name="currency"]'
      ) as HTMLElement;

      if (nav) {
        trapFocus(nav);
      }

      if (item) {
        item.focus();
      }
    }, focusTimeout);
  });

  /* Hide nav and backdrop */
  const closeNav = () => {
    hamburgerIcon.setAttribute("aria-expanded", "false");
    backdrop.classList.remove("backdrop-active");
    nav.classList.remove("navigation-active");
    body.classList.remove("overflow--hidden");

    setTimeout(() => {
      hamburgerIcon.focus();
    }, focusTimeout);
  };

  backdrop.addEventListener("click", closeNav);
  crossIcon.addEventListener("click", closeNav);
};
